import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCameraOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCameraOff"><Path fillRule="evenodd" clipRule="evenodd" d="M8.96482 3L6.96482 6H2V21H22V6H17.0352L15.0352 3H8.96482ZM9.99833 10.0858L12 12.0875L14.0017 10.0858L15.4159 11.5L13.4142 13.5017L15.4142 15.5017L14 16.9159L12 14.9159L10 16.9159L8.58579 15.5017L10.5858 13.5017L8.58412 11.5L9.99833 10.0858Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCameraOff;
